import React from 'react';
import './StudentGuidelines.css';

const StudentGuidelines = () => {
  return (
    <div className="student-guidelines-page">
       {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>STUDENT GUIDELINES</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Student Gudielines</li>
          </ul>
        </div>
      </section>

      <div className="content-section">
        <div className="code-box">
          <h2>CODE OF CONDUCT FOR STUDENTS</h2>
          
          <div className="accent-bar"></div>
          
          <p className="quote">"He That Respect Not, Is Not Respected"</p>
          
          <p className="intro-text">
            In order to cultivate the habit of discipline among the students and to speed up their progress and efficiency, following directions are to be followed by the students of the Academy:
          </p>

          <ol className="guidelines-list">
            <li>Every pupil must have the scholar's diary which should be brought to the Academy daily.</li>
            
            <li>Pupil must be in the Academy premises before the first bell. The warning bell before class is a signal for all to go for Assembly. After Assembly, they should move in lines to their respective class rooms.</li>
            
            <li>All the students should be habitually clean and smartly dressed. This is extremely important.</li>
            
            <li>Private Dress is not allowed.</li>
            
            <li>The name, class and section of the pupil should be clearly marked on her/his belongings.</li>
            
            <li>All the text books and exercise books should have covers on them, and must be maintained properly.</li>
            
            <li>The students should look after their belongings themselves. The Academy is not responsible for articles or money lost. It is advisable not to bring valuable articles like and expensive watch, gold bangles, ear rings etc. to the Academy.</li>
          </ol>

          <div className="section-divider"></div>

          <h3 className="sub-heading">Students of Bihani Children Academy are expected to:</h3>

          <ol className="guidelines-list">
            <li>Be friendly with each other inside as well as out side the Academy.</li>
            
            <li>Be courteous and polite.</li>
            
            <li>Keep the lavatory clean.</li>
            
            <li>Follow the rules of the Academy.</li>
            
            <li>Respect the right of other students.</li>
            
            <li>Respect the beauty of the Academy premises and report any damage if they observe.</li>
            
            <li>Bihani Children's Academy, being a co-educational institution expects all students to respect the traditional limits of their relationships, and adhere to moral values.</li>
          </ol>

          <p className="closing-text">
            The parents and students should co-opretive with the Academy authorities in the implementation of these rules and regulations in the larger interest of the institution.
          </p>

          <p className="motto">"First deserve then desire"</p>
        </div>
      </div>
    </div>
  );
};

export default StudentGuidelines;